import TopNavBar from '../../components/reusables/topNavBar';
import OrdersTable from './ordersTable';

function Orders() {
    return (
        <div className='h-full flex flex-col'>
            <TopNavBar title={"Fila de Pedidos"} subtitle={"Gerencie a fila de pedidos do dia."} />
            <div className='mx-4 sm:mx-10 my-6 flex-1 font-poppins text-custom_lighter_gray_font'>
                <OrdersTable />
            </div>
        </div>
    )

}

export default Orders